<app-page-header [title]="page.translations[lang].title"></app-page-header>

<section class="booster-application">
  <div class="container">
    <h2 class="font-weight-bold text-center">Join the GGBoost Team</h2>

    <div class="alert alert-warning">
      <h5 class="mb-0">{{ page.translations[lang].warning }}</h5>
      <p>
        {{ page.translations[lang].warning1 }}
      </p>
      <p>
        {{ page.translations[lang].warning2 }}
      </p>
      <div class="recruiters">
        <p>{{ page.translations[lang].recruiter }} Discord: dopaggboost.com</p>
        <p>{{ page.translations[lang].recruiter }} Discord: ggboostcpt.jack</p>
        <p>{{ page.translations[lang].assistant }} Discord: senpai_gg</p>
        <p>GGBOOST email: ggboost.com&#64;gmail.com</p>
      </div>
    </div>

    <form [formGroup]="form" (submit)="onSubmit()">

      <div class="form-line">
        <div class="form-group flex">
          <label for="name">{{ page.translations[lang].name }}</label>
          <input id="name" type="text" class="form-control" formControlName="name">
        </div>

        <div class="form-group flex">
          <label for="age">{{ page.translations[lang].age }}</label>
          <input id="age" type="number" class="form-control" formControlName="age" min="0" max="99">
        </div>

        <div class="form-group flex">
          <label>{{ page.translations[lang].country }}</label>
          <app-country-selector [parentForm]="form" [lang]="lang"></app-country-selector>
        </div>
      </div>

      <div class="form-line">
        <div class="form-group flex">
          <label for="email">E-mail *</label>
          <input id="email" type="email" class="form-control" formControlName="email">
        </div>
        <div class="form-group flex">
          <label for="discord">Discord *</label>
          <input id="discord" type="text" class="form-control" formControlName="discord">
        </div>
      </div>

      <div class="form-line">
        <div class="form-group flex">
          <label for="game">{{ page.translations[lang].game }}</label>
          <select id="game" class="form-control" formControlName="game">
            <option value="apex">Apex Legends</option>
            <option value="cs2">Counter Strike 2</option>
            <option value="lol">League of Legends</option>
            <option value="marvel">Marvel Rivals</option>
            <option value="overwatch">Overwatch 2</option>
            <option value="tft">Teamfight Tactics</option>
            <option value="valorant">Valorant</option>
            <option value="wild-rift">Wild Rift</option>
            <!-- <option value="codmw2">COD: Modern Warfare 2</option>
            <option value="codwz2">COD: Warzone 2</option> -->
          </select>
        </div>
        <div class="form-group flex">
          <label for="rank">{{ page.translations[lang].currentRank }}</label>
          <select id="rank" class="form-control" formControlName="rank">
            <ng-container *ngIf="form?.value?.game">
              <option *ngFor="let rank of getRanks(form.value.game)" [value]="DivisionsService.getValueByRank(rank,form.value.game)">{{rank}}</option>
            </ng-container>
          </select>
        </div>
        <div class="form-group flex">
          <label>{{ page.translations[lang].boostRegion }}</label>
          <div class="checkbox-group">
            <div class="form-check">
              <input type="checkbox" id="serverAmericas" class="form-check-input" formControlName="regionAmericas">
              <label for="serverAmericas" class="form-check-label">Americas</label>
            </div>
            <div class="form-check">
              <input type="checkbox" id="serverEurope" class="form-check-input" formControlName="regionEurope">
              <label for="serverEurope" class="form-check-label">Europe</label>
            </div>
            <div class="form-check">
              <input type="checkbox" id="serverOceania" class="form-check-input" formControlName="regionOceania">
              <label for="serverOceania" class="form-check-label">Oceania</label>
            </div>
            <div class="form-check">
              <input type="checkbox" id="serverAsia" class="form-check-input" formControlName="regionAsia">
              <label for="serverAsia" class="form-check-label">Asia</label>
            </div>
          </div>
        </div>

        <div class="form-group flex">
          <label>{{ page.translations[lang].platform }}</label>
          <div class="checkbox-group">
            <div class="form-check">
              <input type="checkbox" id="platformPC" class="form-check-input" formControlName="platformPc">
              <label for="platformPC" class="form-check-label">PC</label>
            </div>
            <div class="form-check">
              <input type="checkbox" id="platformPS" class="form-check-input" formControlName="platformPs">
              <label for="platformPS" class="form-check-label">Playstation</label>
            </div>
            <div class="form-check">
              <input type="checkbox" id="platformXbox" class="form-check-input" formControlName="platformXbox">
              <label for="platformXbox" class="form-check-label">Xbox</label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="form-group flex">
          <label for="averageNumberOfHours">{{ page.translations[lang].avgHours }}</label>
          <select id="averageNumberOfHours" class="form-control" formControlName="averageNumberOfHours">
            <option value="4">2-4 {{ page.translations[lang].hours }}</option>
            <option value="6">4-6 {{ page.translations[lang].hours }}</option>
            <option value="8">6+ {{ page.translations[lang].hours }}</option>
          </select>
        </div>
        <div class="form-group flex">
          <label for="opgg">{{ page.translations[lang].onlineProfile }}</label>
          <input id="opgg" type="text" class="form-control" formControlName="opgg">
        </div>
      </div>

      <div class="form-group">
        <label>{{ page.translations[lang].aboutYou }}</label>
        <textarea style="resize: none;" class="form-control" rows="10" formControlName="introduction"></textarea>
      </div>

      <p>{{ page.translations[lang].pleaseFill }}</p>

      <div class="text-center">
        <app-button ngClass="send-disabled" [disabled]="form.invalid" backgroundType="primary" colorType="light">{{ page.translations[lang].sendApplication }}</app-button>
      </div>
    </form>

  </div>
</section>
